// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VStepperHeader = createSimpleFunctional('v-stepper-header');
//# sourceMappingURL=VStepperHeader.mjs.map